import { BookOpenRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useGetUserManualLinks } from "state/queries/useGetUserManualLinks";
import { DocumentLinkButton } from "./DocumentLinkButton";

/**
 * /usermanuallink returns every document available to the user
 * (manuals, signup information); they are listed in a single menu.
 */
export const HeaderDocumentLinks = () => {
  const { t } = useTranslation();
  const { data: documentLinks, isLoading } = useGetUserManualLinks();

  return (
    <>
      <DocumentLinkButton
        icon={BookOpenRegular}
        label={t("hbh.userManual.label")}
        links={documentLinks}
        isLoading={isLoading}
      />
    </>
  );
};
